import { Amplify } from 'aws-amplify';

const awsConfig = {
  apiEndpoint: process.env.REACT_APP_API_URL || 'http://localhost:3001',
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || ''
};

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsConfig.userPoolId,
      userPoolClientId: awsConfig.userPoolClientId,
      loginWith: {
        email: true
      }
    }
  }
});

export default awsConfig;
